module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/exit@3x.png?1.0.17";